import React, { FC } from 'react';
import { ProjectRow, ProjectsHead, StyledLabel, StyledP } from 'components';
import { AULink } from 'components/AULink';
import { ORDER_DETAILS } from 'constants/navigation';
import { format } from 'date-fns';
import { getOrderStatusLabel } from 'helpers/sales';
import { ActionLabel } from '../MyAccount/styled';
import SalesDataOrder from 'mage-swagfaces/sales/SalesDataOrder';
import { OrderActionsWrapper } from './styled';
import Show from 'components/Functional/Show';
import { handleReorderClick } from 'helpers/cart';

interface MyProjectsPageProps {
  orders: SalesDataOrder[];
}

export const OrdersList: FC<MyProjectsPageProps> = ({ orders }) => {
  return (
    <>
      <ProjectsHead columnWidth="9rem" alignItems="center">
        <StyledLabel>Order Number</StyledLabel>
        <StyledLabel>Date</StyledLabel>
        <StyledLabel>Ship To</StyledLabel>
        <StyledLabel>Order Total</StyledLabel>
        <StyledLabel>Status</StyledLabel>
        <StyledLabel>Action</StyledLabel>
      </ProjectsHead>
      <Show when={!!orders?.length}>
        {orders.map((order) => {
          const date = new Date(order?.created_at ?? Date.now());
          const shipTo = `${order.customer_firstname || ''} ${order.customer_lastname || ''}`;

          return (
            <React.Fragment key={order.entity_id}>
              <ProjectRow columnWidth="9rem" alignItems="center">
                <StyledP secondary>{order.increment_id}</StyledP>
                <StyledP secondary>{format(date, 'M/d/yy')}</StyledP>
                <StyledP secondary>{shipTo}</StyledP>
                <StyledP secondary>{`$${order.grand_total}`}</StyledP>
                <StyledP secondary>{getOrderStatusLabel(order)}</StyledP>
                <OrderActionsWrapper>
                  <ActionLabel>
                    <AULink path={`${ORDER_DETAILS.url}?orderid=${order.entity_id}`} id="view-order">
                      View
                    </AULink>
                  </ActionLabel>
                  <ActionLabel onClick={() => handleReorderClick(order.entity_id)}>Reorder</ActionLabel>
                </OrderActionsWrapper>
              </ProjectRow>
            </React.Fragment>
          );
        })}
      </Show>
    </>
  );
};
